@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Integrações</div>
          <div class="subtitulo_integracao">Configuração do WhatsApp Oficial e definição das etapas do atendimento.</div>
        </div>
        <div class="mt-2 mt-md-0">
          <a class="btn btn-sm btn-outline-primary" routerLink="/whatsapp-oficial">
            Abrir Operação
          </a>
        </div>
      </div>
    </div>
    <div class="pt-3 pr-4 pb-4 pl-4">
      @if (!podeEditar) {
        <div class="alert alert-info">
          Esta tela está disponível para consulta, mas a edição da configuração oficial está restrita à diretoria, master ou financeiro.
        </div>
      }
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-white">
          <strong>WhatsApp Oficial da Meta</strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="mb-1">Nome da conexão</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.nome_conexao" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-2 mb-3">
              <label class="mb-1">Provedor</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.provedor" [disabled]="true" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">Business Account ID</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.business_account_id" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">Phone Number ID</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.phone_number_id" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">Número do WhatsApp</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.numero_whatsapp" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">App ID</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.app_id" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">App Secret</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.app_secret" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="mb-1">Webhook Verify Token</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.webhook_verify_token" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-12 mb-3">
              <label class="mb-1">Access Token</label>
              <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="configuracao.access_token" [disabled]="!podeEditar"></textarea>
            </div>
            <div class="col-md-12 mb-3">
              <label class="mb-1">Webhook URL</label>
              <input class="form-control form-control-sm" [(ngModel)]="configuracao.webhook_url" [disabled]="!podeEditar" />
            </div>
            <div class="col-md-3 mb-3">
              <div class="custom-control custom-switch mt-4">
                <input class="custom-control-input" type="checkbox" id="flagAtivoWhatsappOficial" [(ngModel)]="configuracao.is_active" [disabled]="!podeEditar" />
                <label class="custom-control-label" for="flagAtivoWhatsappOficial">Integração ativa</label>
              </div>
            </div>
          </div>
          @if (podeEditar) {
            <div class="d-flex justify-content-end">
              <button class="btn btn_formulario btn-sm" type="button" (click)="salvarConfiguracao()">
                Salvar Configuração
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
